import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-certificado-curso-tablas-excel',
  templateUrl: './certificado-curso-tablas-excel.component.html',
  styleUrls: ['./certificado-curso-tablas-excel.component.scss']
})
export class CertificadoCursoTablasExcelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
